module.exports = __webpack_public_path__ + "img/todov3-details1.ae677b3e.png";